/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProductDto } from '../../models/backend-product-dto';
import { BackendProductRequestDto } from '../../models/backend-product-request-dto';

export interface OpexesProductsCreate$Params {
  body: BackendProductRequestDto;
}

export function opexesProductsCreate(
  http: HttpClient,
  rootUrl: string,
  params: OpexesProductsCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProductDto>> {
  const rb = new RequestBuilder(rootUrl, opexesProductsCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProductDto>;
    }),
  );
}

opexesProductsCreate.PATH = '/api/opexes/products/';
